import { isLoading } from "./store";
import { trackPurchaseInitiated, trackPurchaseCompleted } from "./utils";
import Stripe from "stripe";
let testMode = false;
let get_user = "";
let add_user = "";
let add_transaction = "";
let get_transaction = "";
let deduct_credits = "";
let fetch_data = "";
let initiate_transaction = "";
let credit_callback = "";
let initiate_premium_monthly = "";
let initiate_premium_monthly_discount = "";
let initiate_premium_annual = "";
let premium_callback = "";
let cancel_premium = "";
let transaction_type = "";
let update_user = "";
let validate_code = "";
let get_promos = "";
let create_promo = "";
let deactivate_promo = "";
let subscription_summary = "";
let transaction_summary = "";
let still_subscribed = "";
let stripe_verify = "";
let api_tierone = "";
let api_tiertwo = "";
let api_tierthree = "";
let api_tierfour = "";
let api_callback = "";
let stripe;
let cancel_api = "";
let api_data = "";
if (testMode) {
    stripe = new Stripe(process.env.STRIPE_DEMO_KEY, {
        apiVersion: '2023-10-16',
    });
    get_user = "http://localhost:3000/getUser/";
    add_user = "http://localhost:3000/addUser";
    add_transaction = "http://localhost:3000/addTransaction";
    get_transaction = "http://localhost:3000/getTransaction/";
    deduct_credits = "http://localhost:3000/deductCredits";
    fetch_data = "http://localhost:3000/fetchData";
    initiate_transaction = "http://localhost:3000/initiateTransaction";
    credit_callback = "http://localhost:3000/creditCallback";
    initiate_premium_monthly = "http://localhost:3000/initiatePremium";
    initiate_premium_monthly_discount = "http://localhost:3000/initiatePremiumMonthlyDiscount";
    initiate_premium_annual = "http://localhost:3000/initiatePremiumAnnual";
    premium_callback = "http://localhost:3000/premiumCallback";
    cancel_premium = "http://localhost:3000/cancelPremium";
    transaction_type = "http://localhost:3000/transactionType";
    update_user = "http://localhost:3000/updateUser";
    validate_code = "http://localhost:3000/validateCode";
    get_promos = "http://localhost:3000/getAllPromoCodes";
    create_promo = "http://localhost:3000/createPromoCode";
    deactivate_promo = "http://localhost:3000/deactivateCode";
    subscription_summary = "http://localhost:3000/subscriptionSummary";
    transaction_summary = "http://localhost:3000/recentTransactions";
    still_subscribed = "http://localhost:3000/checkStillSubscribed";
    stripe_verify = "http://localhost:3000/verifyIdentity";
    api_tierone = "http://localhost:3000/initiateAPItierone";
    api_tiertwo = "http://localhost:3000/initiateAPItiertwo";
    api_tierthree = "http://localhost:3000/initiateAPItierthree";
    api_tierfour = "http://localhost:3000/initiateAPItierfour";
    api_callback = "http://localhost:3000/apiCallback";
    cancel_api = "http://localhost:3000/cancelAPI";
    api_data = "http://localhost:3000/apiData";
}
else {
    stripe = new Stripe(process.env.STRIPE_SECRET_KEY, {
        apiVersion: '2023-10-16',
    });
    get_user = process.env.GETUSER;
    add_user = process.env.ADDUSER;
    add_transaction = process.env.ADDTRANSACTION;
    get_transaction = process.env.GETTRANSACTION;
    deduct_credits = process.env.DEDUCTCREDITS;
    fetch_data = process.env.FETCHDATA;
    initiate_transaction = process.env.INITIATETRANSACTION;
    credit_callback = process.env.CREDITCALLBACK;
    initiate_premium_monthly = process.env.INITIATEPREMIUM;
    initiate_premium_monthly_discount = process.env.INITIATEPREMIUMMONTHLYDISCOUNT;
    initiate_premium_annual = process.env.INITIATEPREMIUMANNUAL;
    premium_callback = process.env.PREMIUMCALLBACK;
    cancel_premium = process.env.CANCELPREMIUM;
    transaction_type = process.env.TRANSACTIONTYPE;
    update_user = process.env.UPDATEUSER;
    validate_code = process.env.VALIDATECODE;
    get_promos = process.env.GET_PROMO_CODE;
    create_promo = process.env.CREATE_PROMO_CODE;
    deactivate_promo = process.env.DEACTIVATE_PROMO_CODE;
    subscription_summary = process.env.SUBSCRIPTION_SUMMARY;
    transaction_summary = process.env.TRANSACTIONSUMMARY;
    still_subscribed = process.env.STILL_SUBSCRIBED;
    stripe_verify = process.env.STRIPE_VERIFY;
    api_tierone = process.env.API_TIERONE;
    api_tiertwo = process.env.API_TIERTWO;
    api_tierthree = process.env.API_TIERTHREE;
    api_tierfour = process.env.API_TIERFOUR;
    api_callback = process.env.API_CALLBACK;
    cancel_api = process.env.CANCEL_API;
    api_data = process.env.API_DATA;
}
export const addUser = async (userData) => {
    const response = await fetch(add_user, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
    });
    if (!response.ok) {
        console.log("Failed to add user.");
    }
    return await response.json();
};
export const getUser = async (id) => {
    try {
        const response = await fetch(get_user + id);
        if (!response.ok) {
            if (response.status === 404) {
                return 0; // User not found
            }
        }
        const userData = await response.json();
        // this is bugging, userData is wrong
        if (userData.identityVerified === undefined) {
            userData.identityVerified = false;
        }
        // add premium = false and lastlogin = new Date() to userData
        // check if the userData first contains those fields
        if (userData.premium === undefined || userData.lastlogin === undefined) {
            // append current user's entry with premium = false and lastlogin = new Date()
            userData.premium = false;
            userData.lastlogin = new Date();
            // update the user's entry in the database
        }
        if (userData.discountCode === undefined || userData.eligibleForDiscount === undefined) {
            userData.discountCode = "";
            userData.eligibleForDiscount = true;
        }
        userData.lastlogin = new Date();
        const newResp = await fetch(update_user, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
        });
        if (!newResp.ok) {
            console.log("Failed to update user.");
        }
        return userData;
    }
    catch (error) {
        console.error("Error getting user: ", error);
    }
};
export const addTransaction = async (transactionData) => {
    try {
        const response = await fetch(add_transaction, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(transactionData),
        });
        if (!response.ok) {
            console.log("Failed to add transaction.");
        }
        return await response.json();
    }
    catch (error) {
        console.error("Error adding transaction: ", error);
    }
};
export const getTransaction = async (transactionID) => {
    try {
        const response = await fetch(get_transaction + transactionID);
        if (!response.ok) {
            if (response.status === 404) {
                return 0; // Transaction not found
            }
            console.log("Failed to get transaction");
        }
        const transactionData = await response.json();
        return transactionData;
    }
    catch (error) {
        console.error("Error getting transaction: ", error);
    }
};
export const deductCredits = async (id, amount) => {
    try {
        const response = await fetch(deduct_credits, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ id, amount }),
        });
        if (!response.ok) {
            return 1; // insufficient credits
        }
        const result = await response.json();
        return result.resultCode;
    }
    catch (error) {
        console.error("Error deducting credits: ", error);
        return 3; // Use a general error code or handle differently as needed
    }
};
export const fetchData = async (accessToken) => {
    isLoading.set(true);
    try {
        const response = await fetch(fetch_data, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ accessToken }),
        });
        if (!response.ok) {
            // console.log(response);
        }
        const userData = await response.json();
        isLoading.set(false);
        return userData;
    }
    catch (error) {
        console.error("Error fetching data: ", error);
        isLoading.set(false);
    }
};
export const initiateTransaction = async (userId, credits, pricePer) => {
    try {
        await trackPurchaseInitiated('Credits', credits);
        const response = await fetch(initiate_transaction, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId, credits, pricePer }),
        });
        if (!response.ok) {
            console.log("Failed to initiate transaction");
        }
        const { url } = await response.json();
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating transaction: ", error);
    }
};
export const creditCallback = async (sessionId) => {
    try {
        const response = await fetch(credit_callback, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ sessionId }),
        });
        if (!response.ok) {
            console.log("Failed to process credit callback");
        }
        const { resultCode } = await response.json();
        if (resultCode == 0) {
            await trackPurchaseCompleted("Credit", 1);
        }
        return resultCode;
    }
    catch (error) {
        console.error("Error processing credit callback: ", error);
        return 3;
    }
};
export const initiatePremiumMonthly = async (userId) => {
    try {
        await trackPurchaseInitiated('Premium_Monthly', 1);
        const response = await fetch(initiate_premium_monthly, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate transaction");
        }
        const { url } = await response.json();
        console.log(url);
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating transaction: ", error);
    }
};
export const initiatePremiumMonthlyDiscount = async (userId) => {
    try {
        await trackPurchaseInitiated('Premium_Monthly_Referral', 1);
        const response = await fetch(initiate_premium_monthly_discount, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate transaction");
        }
        const { url } = await response.json();
        console.log(url);
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating transaction: ", error);
    }
};
export const initiatePremiumAnnual = async (userId) => {
    try {
        await trackPurchaseInitiated("Premium_Annual", 1);
        const response = await fetch(initiate_premium_annual, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate transaction");
        }
        const { url } = await response.json();
        console.log(url);
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating transaction: ", error);
    }
};
export const premiumCallback = async (sessionId) => {
    try {
        const response = await fetch(premium_callback, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ sessionId: sessionId })
        });
        if (!response.ok) {
            console.log("Failed to process premium callback");
        }
        const { resultCode } = await response.json();
        if (resultCode == 0) {
            await trackPurchaseCompleted("Premium", 1);
        }
        return resultCode;
    }
    catch (error) {
        console.error("Error processing premium callback: ", error);
        return 3;
    }
};
export const cancelPremium = async (userId) => {
    try {
        const response = await fetch(cancel_premium, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId: userId }),
        });
        if (!response.ok) {
            console.log("Failed to update user.");
        }
        return await response.json();
    }
    catch (error) {
        console.error("Error getting user: ", error);
    }
};
export const transactionType = async (sessionId) => {
    try {
        const response = await fetch(transaction_type, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ sessionId }),
        });
        if (!response.ok) {
            if (response.status === 404) {
                return 0; // Transaction not found
            }
            console.log("Failed to get transaction");
        }
        const transactionData = await response.json();
        return transactionData;
    }
    catch (error) {
        console.error("Error getting transaction: ", error);
    }
};
export const getPromoDatabase = async (user) => {
    const response = await fetch(get_promos, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ user: user }),
    });
    const data = await response.json();
    // [ { "code": "abc123", "type": "credits", "value": 10, "expiration": { "_seconds": 1717567387, "_nanoseconds": 805000000 }, "redeemedUsers": [ "100554426680457164949", "110554093971457589738" ] }, { "code": "premiumTest", "expiration": { "_seconds": 1717478457, "_nanoseconds": 523000000 }, "type": "premium", "value": 10, "redeemedUsers": [ "100554426680457164949" ] } ]
    // Create a table out of this data and display it as 'result'
    let table = "<table><tr><th>Code</th><th>Type</th><th>Value</th><th>Expiration</th><th>Redeemed Users</th></tr>";
    // for each won't work with data since it's not an array, so we need to use Object.keys(data) to get the keys
    data.promoCodes.forEach((item) => {
        let row = "<tr>";
        row += "<td>" + item.code + "</td>";
        row += "<td>" + item.type + "</td>";
        row += "<td>" + item.value + "</td>";
        row += "<td>" + formatTimestamp(item.expiration) + "</td>"; // Stringify the expiration object
        row += "<td>" + item.redeemedUsers.join(", ") + "</td>"; // Join the redeemedUsers array with commas
        row += "</tr>";
        table += row;
    });
    return table;
};
function formatTimestamp(timestamp) {
    const seconds = timestamp._seconds;
    const nanoseconds = timestamp._nanoseconds;
    const milliseconds = nanoseconds / 1000000;
    const date = new Date(seconds * 1000 + milliseconds);
    return date.toLocaleString();
}
export const createPromo = async (code, type, value, expiration) => {
    const response = await fetch(create_promo, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ code, type, value, expiration }),
    });
    const data = await response.json();
    return data;
};
export const deactivatePromo = async (code, user) => {
    const response = await fetch(deactivate_promo, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ code, user }),
    });
    const data = await response.json();
    return data;
};
export const validateCode = async (code) => {
    try {
        const response = await fetch(validate_code, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ code: code }),
        });
        if (!response.ok) {
            console.log("Failed to validate code");
        }
        const resultCode = await response.json();
        return resultCode.valid;
    }
    catch (error) {
        console.log("Error validating code: ", error);
        console.error("Error validating code: ", error);
        return 3;
    }
};
export const getTransactionSummaryDatabase = async (user) => {
    const response = await fetch(transaction_summary, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ user: user }),
    });
    let data = await response.json();
    data = data.recentTransactions;
    // Filter out transactions with "Stripe fee" in the description
    data = data.filter(item => !item.description.includes("Stripe fee"));
    data.forEach(item => {
        item.date = new Date(item.date).getTime();
    });
    data.sort((a, b) => b.date - a.date);
    data.forEach(item => {
        item.date = new Date(item.date).toLocaleDateString();
        item.amount = `$${parseFloat(item.amount).toFixed(2)}`;
    });
    let table = "<table style='margin-left: auto; margin-right: auto; border-collapse: collapse; font-weight: 200; font-size: 14px;'>";
    table += "<tr>";
    Object.keys(data[0]).forEach(key => {
        table += "<th style='border: 1px solid black; padding: 4px;'>" + key + "</th>";
    });
    table += "</tr>";
    data.forEach(item => {
        let rowStyle = "";
        if (item.description.includes("Subscription renewal")) {
            rowStyle = "background-color: #006751;"; // Green
        }
        else if (item.description.includes("Payout")) {
            rowStyle = "background-color: #020020;"; // Dark blue
        }
        else if (item.description.includes("Refund / Dispute")) {
            rowStyle = "background-color: #ff7e38;"; // Orange
        }
        else if (item.description.includes("Credit Purchase")) {
            rowStyle = "background-color: #008799;"; // Green
        }
        else if (item.description.includes("Subscription creation")) {
            rowStyle = "background-color: #002751;"; // 
        }
        else {
            rowStyle = "background-color: #83769c;"; // Purple
        }
        let row = `<tr style='${rowStyle}'>`;
        Object.values(item).forEach(value => {
            row += "<td style='border: 1px solid black; padding: 4px;'>" + value + "</td>";
        });
        row += "</tr>";
        table += row;
    });
    table += "</table>";
    return table;
};
export const getSubscriptionSummaryDatabase = async (user) => {
    const response = await fetch(subscription_summary, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ user: user }),
    });
    const data = await response.json();
    const values = Object.values(data.calendar);
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    let table = "<table style='margin-left: auto; margin-right: auto; border-collapse: collapse; font-weight: 200; font-size: 14px;'>";
    table += "<tr>";
    Object.keys(data.calendar).forEach((key) => {
        table +=
            "<th style='border: 1px solid black; padding: 4px;'>" +
                key +
                "</th>";
    });
    table += "</tr><tr>";
    // Add revenue row with heatmap coloring
    Object.keys(data.calendar).forEach((key) => {
        const value = data.calendar[key];
        const color = getColor(value, minValue, maxValue);
        table +=
            `<td style='border: 1px solid black; padding: 4px; background-color: ${color};'>$${value}</td>`;
    });
    table += "</tr></table>";
    let results = [table, data];
    return results; // results[0] is the table, results[1] is the data
};
function getColor(value, min, max) {
    const ratio = (value - min) / (max - min);
    const green = Math.floor(155 * ratio);
    return `rgb(0, ${green}, 0)`;
}
export const checkStillSubscribed = async (userId) => {
    try {
        // console.log("Checking subscription status of user: ", userId);
        const response = await fetch(still_subscribed, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to check subscription status");
        }
        const subscribed = await response.status;
        return subscribed;
    }
    catch (error) {
        console.error("Error checking subscription status: ", error);
        return 3;
    }
};
export const verifyIdentity = async (userId) => {
    try {
        const response = await fetch(stripe_verify, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to verify identity");
        }
        const verified = await response.json();
        // console.log("Existing verification session id: ", verified.verificationSessionId);
        const sessioncreated = await stripe.identity.verificationSessions.retrieve(verified.verificationSessionId);
        window.location.href = sessioncreated.url;
    }
    catch (error) {
        console.error("Error verifying identity: ", error);
        return 3;
    }
};
export const verificationComplete = async (userId) => {
    try {
        // userId will be listed as 'user' in the metadata of the verification session
        // check each verification session for the user's ID
        const sessions = await stripe.identity.verificationSessions.list();
        for (let i = 0; i < sessions.data.length; i++) {
            if (sessions.data[i].metadata.userId == userId) {
                const session = await stripe.identity.verificationSessions.retrieve(sessions.data[i].id);
                if (session.status === "verified") {
                    const userData = await getUser(userId);
                    userData.identityVerified = true;
                    const newResp = await fetch(update_user, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(userData),
                    });
                    if (!newResp.ok) {
                        console.log("Failed to update user.");
                    }
                    window.location.reload();
                    return true;
                }
                else {
                    // console.log("User has not been verified");
                    return false;
                }
            }
        }
    }
    catch (error) {
        console.error("Error verifying identity: ", error);
        return false;
    }
};
export const initiateAPItierone = async (userId) => {
    try {
        await trackPurchaseInitiated("API_Tier_One", 1);
        const response = await fetch(api_tierone, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate API tier one");
        }
        const { url } = await response.json();
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating API tier one: ", error);
    }
};
export const initiateAPItiertwo = async (userId) => {
    try {
        await trackPurchaseInitiated("API_Tier_Two", 1);
        const response = await fetch(api_tiertwo, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate API tier two");
        }
        const { url } = await response.json();
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating API tier two: ", error);
    }
};
export const initiateAPItierthree = async (userId) => {
    try {
        await trackPurchaseInitiated("API_Tier_Three", 1);
        const response = await fetch(api_tierthree, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate API tier three");
        }
        const { url } = await response.json();
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating API tier three: ", error);
    }
};
export const initiateAPItierfour = async (userId) => {
    try {
        await trackPurchaseInitiated("API_Tier_Four", 1);
        const response = await fetch(api_tierfour, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to initiate API tier four");
        }
        const { url } = await response.json();
        // Redirect to the Stripe Checkout page
        window.location.href = url;
    }
    catch (error) {
        console.error("Error initiating API tier four: ", error);
    }
};
export const apiCallback = async (sessionId) => {
    try {
        const response = await fetch(api_callback, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ sessionId }),
        });
        if (!response.ok) {
            console.log("Failed to process api callback");
        }
        const { resultCode } = await response.json();
        return resultCode;
    }
    catch (error) {
        console.error("Error processing api callback: ", error);
        return 3;
    }
};
export const cancelAPI = async (userId) => {
    try {
        const response = await fetch(cancel_api, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId: userId }),
        });
        if (!response.ok) {
            console.log("Failed to cancel api.");
        }
        return await response.json();
    }
    catch (error) {
        console.error("Error getting user: ", error);
    }
};
export const getAPISubscription = async (userId) => {
    try {
        const response = await fetch(api_data, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to get API subscription");
        }
        const apiData = await response.json();
        return apiData;
    }
    catch (error) {
        console.error("Error getting API subscription: ", error);
    }
};
